import { render, staticRenderFns } from "./PreviewExplain.vue?vue&type=template&id=7284583a&scoped=true&"
import script from "./PreviewExplain.vue?vue&type=script&lang=js&"
export * from "./PreviewExplain.vue?vue&type=script&lang=js&"
import style0 from "./PreviewExplain.vue?vue&type=style&index=0&id=7284583a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7284583a",
  null
  
)

export default component.exports